/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1AssociatedcompanyIdAttachment204,
  DeleteApiV1AssociatedcompanyIdAttachment401,
  DeleteApiV1AssociatedcompanyIdAttachment404,
  DeleteApiV1AssociatedcompanyIdAttachment500,
  DeleteApiV1AssociatedcompanyIdAttachmentMutationResponse,
  DeleteApiV1AssociatedcompanyIdAttachmentPathParams,
} from "../../types/associatedCompanyAttachmentController/DeleteApiV1AssociatedcompanyIdAttachment.ts";

export const deleteApiV1AssociatedcompanyIdAttachmentPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1AssociatedcompanyIdAttachmentPathParams>;

/**
 * @description Contrato removido.
 */
export const deleteApiV1AssociatedcompanyIdAttachment204Schema =
  z.any() as unknown as ToZod<DeleteApiV1AssociatedcompanyIdAttachment204>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1AssociatedcompanyIdAttachment401Schema =
  z.any() as unknown as ToZod<DeleteApiV1AssociatedcompanyIdAttachment401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1AssociatedcompanyIdAttachment404Schema =
  z.any() as unknown as ToZod<DeleteApiV1AssociatedcompanyIdAttachment404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1AssociatedcompanyIdAttachment500Schema =
  z.any() as unknown as ToZod<DeleteApiV1AssociatedcompanyIdAttachment500>;

export const deleteApiV1AssociatedcompanyIdAttachmentMutationResponseSchema =
  z.lazy(
    () => deleteApiV1AssociatedcompanyIdAttachment204Schema,
  ) as unknown as ToZod<DeleteApiV1AssociatedcompanyIdAttachmentMutationResponse>;
